export const normalizeCollectionModeKey = (value: unknown): string =>
	String(value ?? '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')

export const isLanguageReviewMode = (value: unknown): boolean =>
	['language_review'].includes(
		normalizeCollectionModeKey(value)
	)

export const normalizeCollectionModeForRequest = (value: unknown): string => {
	const raw = String(value ?? '').trim()
	const key = normalizeCollectionModeKey(raw)

	if (isLanguageReviewMode(key)) {
		return 'language_review'
	}

	return raw
}
